import React, { Component } from 'react';
import { CardWrapper, PageWrapper, Title, SubtitleH3, ConfirmWrapper, ImageContainer, Img, BoxPadding, BorderBox } from '../../styles';
import LayoutStyle from '../../components/layout/Layout';
import Card from './Card';
import styled from 'styled-components';

export class Confirm extends Component {
  componentDidMount(){
    this.props.cookies.remove('hasSubmit', { expires: '1970-01-01'});
    this.props.cookies.remove('email', { expires: '1970-01-01'});
    this.props.cookies.remove('isVerfied', { expires: '1970-01-01'});
  }
  render() {
    return (
      <LayoutStyle>
        <ConfirmWrapper>
          <ImageContainer>
            <Img src='https://zervicepoint.com/wp-content/uploads/2019/11/zp_logo_name.svg' />
          </ImageContainer>
          <BorderBox>
            <BoxPadding>
              <Title>Congrats! Your store is on its way.
                <SubtitleH3>While things are getting ready, we thought you might want to learn more about Zervicepoint.</SubtitleH3>
                <CardWrapper>
                  <Card link='https://docs.zervicepoint.com/intro/zervicepoint-at-a-glance/' label={'This is Zervicepoint'} text={'Learn about what you can do with the platform'} image={'https://www.zervicepoint.com/wp-content/uploads/sign-up/zervicepoint_self_service_desktop.png'}/>
                  <Card link='https://docs.zervicepoint.com/tutorials/create-your-first-services/' label={'Create your first service'} text={'Check out the guides'} image={'https://www.zervicepoint.com/wp-content/uploads/sign-up/adminweb_create_service.png'}/>
                </CardWrapper>
              </Title>
            </BoxPadding>
          </BorderBox>
        </ConfirmWrapper>
      </LayoutStyle>
    );
  }
}

export default Confirm;
